import { Animal } from "../../types/rtk/animal/animal";
import { Breed, BreedsResponse } from "../../types/rtk/breeds/breeds";
import { apiSlice } from "../_api/api-slice";

interface Args {
  id?: string;
  trackerId?: string;
  body?: Partial<Animal>;
}

interface GetBreedsArgs {
  species?: "Cat" | "Dog";
  language: "fr" | "en" | "de" | "nl" | "es" | "it";
}

export const animal = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAnimal: build.query<{ items: Animal[]; total: number }, string>({
      query: (trackerId) => ({
        url: `/animal?tracker_id=${trackerId}`,
        method: "get",
      }),
    }),
    addAnimal: build.mutation<Animal, Args>({
      query: ({ body }) => ({
        url: `/animal`,
        method: "post",
        body,
      }),
    }),
    updateAnimal: build.mutation<Animal, Args>({
      query: ({ body, id }) => ({
        url: `/animal/${id}`,
        method: "put",
        body,
      }),
    }),
    getBreeds: build.query<Breed[], GetBreedsArgs>({
      query: ({ species, language }) => {
        const params = new URLSearchParams({
          language,
          limit: "1000",
        });

        if (species) {
          params.append("species", species);
        }

        return {
          url: `/breeds?${params.toString()}`,
          method: "get",
        };
      },
      transformResponse: (response: BreedsResponse) => {
        return response.items;
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetAnimalQuery,
  useAddAnimalMutation,
  useUpdateAnimalMutation,
  useGetBreedsQuery,
} = animal;
